(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root?.document) api.boot(root.document);
})(typeof window === 'object' ? window : null, function () {
  'use strict';
  const regions = new Set(['TN', 'NC', 'SC', 'GA']);
  const sources = new Set(['manual', 'estimated']);
  function installationRegion(destination) {
    // These are exact validated values emitted by fcs-shipping-destination.js.
    // A country default, unvalidated region or unknown source grants no offer.
    if (destination?.country !== 'US' || !regions.has(destination.province) || !sources.has(destination.source)) return { eligible: false };
    return { eligible: true, province: destination.province };
  }
  function readDestination(document) {
    const banner = document.querySelector('[data-fcs-shipping-destination]');
    return banner ? { country: banner.dataset.fcsShippingCountry, province: banner.dataset.fcsShippingProvince, source: banner.dataset.fcsShippingSource } : null;
  }
  function boot(document) {
    if (document.__fcsProductInstallationBooted) return;
    document.__fcsProductInstallationBooted = true;
    let destination = readDestination(document);
    function render(card) {
      const region = installationRegion(destination);
      card.hidden = !region.eligible;
      if (region.eligible) card.dataset.fcsInstallationProvince = region.province;
      else card.removeAttribute('data-fcs-installation-province');
    }
    function scan(scope) {
      const cards = scope.matches?.('[data-fcs-product-installation]') ? [scope] : scope.querySelectorAll?.('[data-fcs-product-installation]') || [];
      Array.from(cards).forEach(render);
    }
    document.addEventListener('fcs:shipping-destination', event => {
      destination = event.detail || null;
      scan(document);
    });
    document.addEventListener('shopify:section:load', event => scan(event.target));
    const Observer = document.defaultView?.MutationObserver;
    if (Observer) new Observer(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); }))).observe(document.documentElement, { childList: true, subtree: true });
    scan(document);
  }
  return { installationRegion, readDestination, boot };
});
